module.exports = __webpack_public_path__ + "assets/65.jpg?b707dddf35a0b0c6c0ada5b2b6d860b4";